import { defineCustomElement } from "vue";
import Header from "./pages/header/ui/Header.ce.vue";

if (!customElements.get("its-header")) {
  customElements.define("its-header", defineCustomElement(Header));
}
